<template>
  <div>
    <tab-menu :initialActiveTab="activeTab"></tab-menu>
    <div v-for="item in listOfItems" :key="item.id" :id="item.id">
      <collapsible-panel :data="data" :initShowExpanded="item.expanded" :heading="item.heading" :extraContent="item.extra_content" :content="item.content"></collapsible-panel>
    </div>
    <div v-if="data && 'metadata' in data && data.metadata.data_source" class="dashboard-note py-2">
      All presented results are based on ESCAP calculations using the {{ data.metadata.data_source }}.
    </div>
    <!-- <vsa-list :init-active="true" :auto-collapse="false">
      <vsa-item v-for="item in listOfItems" :key="item.id">
        <vsa-heading>
          {{ item.heading }}
        </vsa-heading>

        <vsa-icon>
          <span class="open"><i class="uil uil-plus-circle" style="font-size: 18px;"></i></span>
          <span class="close"><i class="uil uil-minus-circle" style="font-size: 18px;"></i></span>
        </vsa-icon>

        <vsa-content>
          <div>
            {{ item.content }}
          </div>
        </vsa-content>
      </vsa-item>
    </vsa-list> -->
  </div>
</template>

<script>
import CollapsiblePanel from '@/components/CollapsiblePanel.vue';
import TabMenu from '@/components/TabMenu.vue';
import _ from 'lodash';
import {
  VsaContent,
  VsaHeading,
  VsaIcon,
  VsaItem,
  VsaList
} from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  // ...
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    TabMenu,
    CollapsiblePanel
  },
  // ...
  data: function () {
    return {
      listOfItems: [
        {
          id: 'distribution_access_section',
          expanded: true,
          heading: 'Distribution of Groups',
          extra_content: 'distribution_access',
          content: 'This dot plot visualizes the different groups in the baseline LNOB tree (shown below) before and after the cash transfer under selected scheme(s).  The size of the dot indicates the group size, and the position indicates the group average. For opportunity indicators such as access to basic drinking water or clean fuel for cooking, the average represents the share of individuals or households in each group having access; for barrier indicators such as overcrowding, the value represents the prevalence of the barrier.   The red line denotes the national average.  Following the cash transfer, some individuals or households may shift to a different group in the baseline LNOB tree, resulting in changes in group sizes and in the national weighted average access or prevalence.'
        },
        {
          id: 'decision_tree_section',
          expanded: true,
          heading: 'Baseline LNOB Tree',
          extra_content: 'decision_tree',
          content: '<h4>LNOB Tree</h4>This binary regression tree or LNOB tree disaggregates the outcome indicator at the national level and identifies mutually exclusive groups based on a pre-selected set of circumstances with different levels of access or prevalence. The LNOB tree captures the intersection of circumstances that drive inequality of opportunity. Understanding this baseline LNOB tree helps interpret the results below. Furthest behind groups are denoted with an orange color. As a group, they have the lowest access to an opportunity or the highest prevalence of experiencing a barrier. Furthest ahead groups are denoted with a blue color. As a group, they have the highest access to an opportunity or the lowest prevalence of experiencing a barrier. For more details, click on the “Information” tab below the LNOB tree.'
        },
        {
          id: 'group_size_changes_section',
          expanded: true,
          heading: 'Shifts between Groups',
          extra_content: 'group_size_changes',
          content: 'This is a Sankey diagram visualizing shifts across different groups identified by the baseline LNOB tree before and after the cash transfer. As social protection benefits are assumed to boost household consumption, individuals or households receiving any benefit may transit to a different group with a higher consumption level and a different group access/prevalence rate. Please note that no movements are expected if the baseline LNOB tree does not feature household consumption as one of the factors contributing to inequality.'
        },
        {
          id: 'inequality_analysis_section',
          expanded: true,
          heading: 'Inequality Analysis',
          extra_content: 'inequality_analysis',
          content: 'In a Lorenz curve, the horizontal axis represents the cumulative percentage of the population, ranked here from lowest to highest level of access/prevalence, while the vertical axis represents the cumulative percentage of total access/prevalence held by those individuals or households. The curve typically starts at the origin (0,0) and rises as it moves to the right, demonstrating how access/prevalence becomes increasingly concentrated among a smaller portion of the population. The more bowed the curve is away from the line of perfect equality (a straight diagonal line from the origin to the upper right corner), the greater the level of inequality in the society. A perfect equality scenario would be represented by a diagonal line, meaning that every group in our population has the same level of access/prevalence.'
        },
        {
          id: 'inequality_metrics_section',
          expanded: true,
          heading: 'Inequality Metrics',
          extra_content: 'inequality_metrics',
          content: 'The change in average access/prevalence before and after cash transfer is also displayed in the table below. The change in national average is driven by changes in access/prevalence rates among different groups. If there are no shifts across groups, then no change is expected in national average access/prevalence before and after the policy reform. The table also provides insight into how various inequality metrics (Gini coefficient, Theil index, Atkinson index) change between the baseline and the simulated results.'
        },
        {
          id: 'cost_analysis_section',
          expanded: true,
          heading: 'Cost Analysis',
          extra_content: 'cost_analysis_table',
          content: ''
        }
      ],
      activeTab: 0,
      data: {}
    };
  },
  computed: {
    ...mapGetters('analysis', [
      'getSp2lnobConfigs'
    ]),
    ...mapState('analysis', [
      'sp2lnobConfigs'
    ])
  },
  watch: {
    sp2lnobConfigs: async function (newValue, oldValue) {
      // console.log(newValue);
      // console.log(oldValue);
      const oldValClone = _.cloneDeep(oldValue);
      const newValClone = _.cloneDeep(newValue);
      if ('detailScenario1' in oldValClone && 'circumstances_labels' in oldValClone.detailScenario1) {
        delete oldValClone.detailScenario1.circumstances_labels;
      }
      if ('detailScenario1' in newValClone && 'circumstances_labels' in newValClone.detailScenario1) {
        delete newValClone.detailScenario1.circumstances_labels;
      }
      if (_.isEqual(newValClone, oldValClone)) {
        return;
      }
      // console.log(JSON.stringify(this.getSp2lnobConfigs));
      this.listOfItems[this.getSp2lnobConfigs.activeTab].expanded = false;
      // console.log(this.getSp2lnobConfigs.activeTab);
      setTimeout(() => {
        this.listOfItems[this.getSp2lnobConfigs.activeTab].expanded = true;
        setTimeout(() => {
          document.getElementById(this.listOfItems[this.getSp2lnobConfigs.activeTab].id).scrollIntoView();
        }, 100);
      }, 100);

      if (this.getSp2lnobConfigs.detailScenario1) {
        // Get SP2LNOB Data from API: https://sp2lnob.thinkbluedata.org/process?country=khm&variable=clean_fuel&child_benefit=44&elderly_benefit=16&disability_benefit=22&debug=false
        // console.log(JSON.stringify(this.getSp2lnobConfigs.detailScenario1.outcome_variables));
        let country_code = 'khm';
        if ('country_obj' in this.getSp2lnobConfigs.detailScenario1 && this.getSp2lnobConfigs.detailScenario1.country_obj.field_code) {
          country_code = this.getSp2lnobConfigs.detailScenario1.country_obj.field_code.toLowerCase();
        }
        if (country_code in this.getSp2lnobConfigs.detailScenario1.outcome_variables && this.getSp2lnobConfigs.detailScenario1.outcome_variables[country_code].map(ov => ov.id).includes(this.getSp2lnobConfigs.detailScenario1.outcome_variable)) {
          const filterString = 'country=' + country_code + '&variable=' + this.getSp2lnobConfigs.detailScenario1.outcome_variable + '&child_benefit=' + (this.getSp2lnobConfigs.detailScenario1.scheme_details[0].is_selected ? (this.getSp2lnobConfigs.detailScenario1.scheme_details[0].benefit_percent / 100) : 0) + '&elderly_benefit=' + (this.getSp2lnobConfigs.detailScenario1.scheme_details[1].is_selected ? (this.getSp2lnobConfigs.detailScenario1.scheme_details[1].benefit_percent / 100) : 0) + '&disability_benefit=' + (this.getSp2lnobConfigs.detailScenario1.scheme_details[2].is_selected ? (this.getSp2lnobConfigs.detailScenario1.scheme_details[2].benefit_percent / 100) : 0) + '&target_bottom_40=' + (this.getSp2lnobConfigs.detailScenario1.scheme_details[0].is_selected ? (this.getSp2lnobConfigs.detailScenario1.scheme_details[0].pmt ? 3 : 1) : 1) + '&debug=false';
          // console.log(filterString);
          const sp2lnobData = await this.getSp2lnobDataByFilters(filterString);
          // console.log(sp2lnobData);
          const costAnalysisDes = 'This table shows the breakdown of costs for each selected benefit. All monetary values are in [[CUR]]. Administrative costs are set at 5% for universal programs and 10% for targeted programs.<p><strong>[[NOTE]]</strong></p>';
          this.listOfItems[5].content = costAnalysisDes.replace('[[NOTE]]', sp2lnobData.metadata.cost_analysis_footer).replace('[[CUR]]', country_code === 'khm' ? 'KHR' : 'MVR');
          this.data = sp2lnobData;
        }
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions('analysis', [
      'getSp2lnobDataByFilters'
    ]),
    handleScroll (event) {
      // Any code to be executed when the window is scrolled
      const offsetTop = window.scrollY || 0;
      // console.log(offsetTop);
      let idx = 0;
      for (const it of this.listOfItems) {
        if (offsetTop + 235 < document.getElementById(it.id).offsetTop) {
          break;
        }
        idx = idx + 1;
      }
      // console.log(offsetTop, document.getElementById(this.listOfItems[idx].id).offsetTop);
      this.activeTab = idx === 0 ? 0 : idx - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.vsa-item {
  &--is-active {
    .vsa-item__trigger__icon {
      .open {
        display: none;
      }

      .close {
        display: block;
      }
    }
  }
  &__trigger__icon {
    .open {
      display: block;
    }

    .close {
      display: none;
    }
  }
}
.col-12 .vsa-list {
  max-width: 95%;
  margin: auto;
}
#cost_analysis_section, #decision_tree_section, #distribution_access_section, #group_size_changes_section, #inequality_analysis_section, #inequality_metrics_section {
  scroll-margin-top: 230px;
}
.dashboard-note {
  color: #2E2E2E;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 95%;
  margin: 10px auto;
}
</style>
